import { render, staticRenderFns } from "./ParcelGalleryDetail.vue?vue&type=template&id=7f001fea&scoped=true&"
import script from "./ParcelGalleryDetail.vue?vue&type=script&lang=js&"
export * from "./ParcelGalleryDetail.vue?vue&type=script&lang=js&"
import style0 from "./ParcelGalleryDetail.vue?vue&type=style&index=0&id=7f001fea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f001fea",
  null
  
)

export default component.exports